import type { IExtractRouteParamMap } from "../../../types";
import { facultyRoutesObj, facultyBreadcrumbs } from "../faculty/path";
import {
  academicGroupRoutesObj,
  academicGroupRouteTranslation,
} from "../academicGroup/path";

import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
  rebase,
} from "@/routes/utils";

const baseRoute = facultyRoutesObj.view;

// * Route configuration object for faculty-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const facultyAcademicGroupsRoutesObj = {
  list: `${baseRoute}${academicGroupRoutesObj.list}`,
  create: `${baseRoute}${academicGroupRoutesObj.create}`,
  view: `${baseRoute}${academicGroupRoutesObj.view}`,
  edit: `${baseRoute}${academicGroupRoutesObj.edit}`,
} as const;

// * Extracts the route parameters for the faculty route configuration.
export type IFacultyAcademicGroupsRouteParams = IExtractRouteParamMap<
  typeof facultyAcademicGroupsRoutesObj
>;

// * Path functions for the facultyAcademicGroups routes.
export const facultyAcademicGroupsPath = createPaths<
  typeof facultyAcademicGroupsRoutesObj,
  IFacultyAcademicGroupsRouteParams
>(facultyAcademicGroupsRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
const newAcademicGroupBreadcrumbs = createBreadcrumbObject<
  typeof facultyAcademicGroupsRoutesObj
>(facultyAcademicGroupsRoutesObj, academicGroupRouteTranslation);

rebase(newAcademicGroupBreadcrumbs, "list");

export const facultyAcademicGroupsBreadcrumbs = concatBreadcrumbs<
  typeof facultyAcademicGroupsRoutesObj
>(facultyBreadcrumbs.view, newAcademicGroupBreadcrumbs);
